import { Container, CssBaseline } from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

const useStyles = makeStyles((theme) => ({
    background: {
        width: '100%',
        height: '100%',
        minHeight: '100vh',
        display: 'flex',
        flex: 'auto',
        flexDirection: 'column',
        overflowX: 'hidden',
        background: `url("/images/background.png")`,
        backgroundSize: 'auto',
        // justifyContent: "center",
        alignItems: 'center',
    },
    backgroundEmpty: {
        width: '100%',
        height: '100%',
        minHeight: '100vh',
        display: 'flex',
        flex: 'auto',
        flexDirection: 'column',
        overflowX: 'hidden',
        background: '#fff',
        backgroundSize: 'auto',
        // justifyContent: "center",
        alignItems: 'center',
    },
    content: {
        width: '100%',
        padding: '5vh 8vw 0',
        [theme.breakpoints.up('md')]: {
            maxWidth: '550px',
            padding: '10vh 0 0',
            margin: '0 10vw',
        },
    },
    root: {
        padding: '0',
        margin: '0',
    },
}));

const HeaderEmptyLayout = (props: any) => {
    const classes = useStyles();
    const { isBackground } = props;
    const { children } = props;
    return (
        <>
            <CssBaseline />
            <div
                className={
                    isBackground ? classes.background : classes.backgroundEmpty
                }
                translate="no"
            >
                <div className={classes.content}>
                    <Container className={classes.root} component="main">
                        {children}
                    </Container>
                </div>
            </div>
        </>
    );
};

export default HeaderEmptyLayout;
